'use client';

export type UseClickTargetProps = {
  id: string;
  isShowing: boolean;
  hide: () => void;
  show: () => void;
};

export type TargetClickBindingProps = {
  'aria-haspopup':
    | boolean
    | 'dialog'
    | 'menu'
    | 'false'
    | 'true'
    | 'listbox'
    | 'tree'
    | 'grid';
  'aria-expanded': boolean;
  'aria-controls': string;
  tabIndex: 0;
  onKeyDown: (e: React.KeyboardEvent) => void;
  onMouseDown: (e: React.MouseEvent) => void;
};

export function useClickTarget({
  id,
  isShowing,
  hide,
  show,
}: UseClickTargetProps): TargetClickBindingProps {
  function toggle() {
    if (isShowing) {
      hide();
      return;
    }
    show();
  }

  return {
    'aria-haspopup': true,
    'aria-expanded': isShowing,
    // @ts-expect-error FIXME(strictNullChecks)
    'aria-controls': isShowing ? id : undefined,
    tabIndex: 0,
    // Since we no longer rely on native click events, we need
    // to emulate click behavior via keyboard.
    onKeyDown: (e: React.KeyboardEvent) => {
      if (e.key === 'Enter') {
        toggle();
      }
    },
    // We no trigger popovers to appear onMouseDown
    onMouseDown: toggle,
  };
}
